import { gql } from '@apollo/client';

export const SmartImportQueryName = 'SmartImport';

export const SMART_IMPORT_FIELDS = gql`
  fragment SmartImportFields on SmartImport {
    id
    createdBy
    importMode
    status
    originalFilename
    sourceFormat
    rowCount
    analysis {
      delimiter
      encoding
      headers
      rowCount
      warnings {
        code
        field
        severity
        message
        evidence
      }
      previewRows {
        rowRef
        sourceRowNumber
        cells {
          column
          value
        }
      }
    }
    overrides {
      global {
        siteId
      }
      rows {
        rowRef
        overrides {
          siteId
        }
      }
    }
    progress {
      processedRowCount
      totalRowCount
      currentChunk
      totalChunks
    }
    draft {
      revision
      sessions {
        sessionRef
        include
        name
        note
        startedAt
        endedAt
        activeDurationSeconds
        distanceMeters
        findRowRefs
        warnings {
          code
          field
          severity
          message
          evidence
        }
        needsReview
      }
      rows {
        rowRef
        sourceRowNumber
        include
        find {
          name
          evId
          foundAt
          description
          era
          type
          note
          siteId
          material
          localization
          longitude
          latitude
          visibility
          tags
        }
        archaeologicalDescription
        archaeologicalDescriptionTarget
        rawCells {
          column
          value
        }
        warnings {
          code
          field
          severity
          message
          evidence
        }
        needsReview
      }
    }
    error {
      code
      message
    }
    knowledgeVersion
    promptVersion
    schemaVersion
    providerModel
    inputTokens
    outputTokens
    retryCount
    expiresAt
    sourceDeletedAt
    createdAt
    updatedAt
    startedAt
    completedAt
    committedFindIds
    committedFieldSessionIds
  }
`;

export const SMART_IMPORT_QUERY = gql`
  query ${SmartImportQueryName}($id: ID!) {
    smartImport(id: $id) {
      ...SmartImportFields
    }
  }
  ${SMART_IMPORT_FIELDS}
`;
